import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/industries/components/BenefitTabsDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/industries/components/IndustryHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/industries/components/IndustryWheel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/integrations/[uid]/components/RelatedIntegrations.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/benchmark-range.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/complexity-game.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/complexity-game/integrations-picker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/complexity-game/result.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/connector-failures.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/consolidation.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/cost-curve.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/education-gratuity-accrual.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/education.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/family-office.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/family-office2.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/fihv-split.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/funding-checker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/inventory-trap.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/multi-entity.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/osl-custody.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/retention-window.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/revenue-recognition.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/tier-checker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/timeline-settlement.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/charts/tourist-split.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/vercel/path0/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LongQuotesSlider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ModalVideoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/SplashButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["SliceSimulator"] */ "/vercel/path0/node_modules/@prismicio/next/dist/SliceSimulator.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/vercel/path0/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/globe-bg.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/globe-bg.png");
